<template>
  <div class="pe-box">
    <div class="image-area">
      <div
        class="bg"
        v-for="(n, index) in homeBg"
        :key="index"
        :style="bgStyle[index]"
      ></div>
    </div>
    <div class="demo-area">
      <div class="demo-inset">
        <h1>旅行・出張・駐在・留学のあらゆるシーンで役立つ機能が満載！</h1>
        <div class="btn-outer-area" v-if="!isAndroid">
          <Button type="dashed" ghost class="down-load ios" @click="download()">
            <!-- <Icon
            type="md-download"
            class="download-icon"
          /> -->
            <span>
              <img :src="iosStore" />
              App Storeへ
            </span>
          </Button>
        </div>
        <div class="btn-outer-area" v-if="isAndroid">
          <Button
            type="dashed"
            ghost
            class="down-load android0"
            @click="download()"
          >
            <!-- <Icon
            type="md-download"
            class="download-icon"
          /> -->
            <img :src="androidStore" />
            <span style="text-align: left">
              アプリ<br />
              ストアへ
            </span>
          </Button>
          <div style="width: 0.4rem"></div>
          <a href="https://data.nanaco.com.cn/nanaco-data/apk/nanacoLatest.apk">
            <Button type="dashed" ghost class="down-load android1">
              <!-- <Icon
            type="md-download"
            class="download-icon"
          /> -->
              <img :src="androidAPK" />
              <span style="text-align: left">
                APKファイルを<br />
                直接ダウンロード
              </span>
            </Button>
          </a>
        </div>

        <!-- <p>選りすぐりのサービスを統合し、あなたの中国生活を“快適”に誘うゲートウェイです。中国生活のさまざまなシーンで直面する「困った！」を解決！</p> -->
        <div class="demo-arrow">
          <Icon type="ios-arrow-dropdown-circle" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { homeBg } from "../../images/home/index";
import download from "../js/download";
import { iosStore, androidStore, androidAPK } from "../../images/pe-icon/index";

export default {
  data() {
    return {
      homeBg,
      bgStyle: [],
      iosStore,
      androidStore,
      androidAPK,
      boxPosition: 0,
      /// ///////////////////////////////////////////////////////////
      /// ////////////////////////添加新的图片时务必修改此参数
      /// ///////////////////////////////////////////////////////////
      bgLength: 4,
      isAndroid: false,
    };
  },
  created() {
    this.$nextTick(() => {
      this.init();
    });
  },
  methods: {
    init() {
      let u = navigator.userAgent;
      let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; // g
      // let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
      if (isAndroid) {
        // alert(123456)
        this.isAndroid = true;
      }
      this.homeBg.forEach((n, index) => {
        let newStyle = "";
        newStyle += "background-image: url(" + n + ");";
        newStyle += "opacity:1;";
        newStyle += "left:" + index * 12.5 + "%;";
        this.bgStyle.push(newStyle);
      });
    },
    timerSet() {},
    up() {
      this.boxPosition = "-100";
    },
    nomal() {
      this.boxPosition = "0";
    },
    down() {
      this.boxPosition = "100";
    },
    download() {
      download();
    },
  },
};
</script>
<style scoped>
.image-area {
  width: 800%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  animation: round 50s infinite linear;
}

.bg {
  width: 12.5%;
  background-position: center center;
  background-size: cover;
  height: 100%;
  left: 0;
  position: absolute;
  opacity: 0;
  display: inline-block;
  transition: all 0.5s;
}

.demo-area {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  z-index: 1;
  text-align: center;
  color: #fff;
  box-sizing: border-box;
  padding-top: 3rem;
}

.demo-inset {
  width: 100%;
  margin: 0 auto;
  height: 100%;
  box-sizing: border-box;
  padding: 15% 0 0 0;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
}

.demo-inset h4 {
  width: 19rem;
  text-align: center;
  font-size: 0.8rem;
  position: absolute;
  font-size: 0.8rem;
  top: 8rem;
  left: 50%;
  margin-left: -9.5rem;
}

.demo-inset h1 {
  width: 18rem;
  text-align: center;
  font-size: 1.2rem;
  letter-spacing: 0.5rem;
  position: absolute;
  line-height: 2rem;
  top: 12rem;
  left: 50%;
  margin-left: -9rem;
  /* background: -webkit-linear-gradient(
    45deg,
    #70f7fe,
    #fbd7c6,
    #fdefac,
    #bfb5dd,
    #bed5f5,
    #70f7fe
  ); */
  -webkit-background-clip: text;
  animation: ran 10s linear infinite;
}

.demo-inset p {
  margin: 0 auto;
  margin-top: 25px;
  font-size: 21px;
  font-weight: bold;
  letter-spacing: 7px;
  width: 100%;
}

.demo-arrow {
  position: absolute;
  width: 50px;
  height: 50px;
  left: 0;
  right: 0;
  bottom: 25px;
  margin: auto;
  font-size: 35px;
  opacity: 1;

  /* animation: jumper 3s infinite linear; */
}

a {
  display: block;
  margin: 0 auto;
}

.down-load {
  width: 8rem;
  height: 3.5rem;
  display: block;
  margin: 0 auto;
  margin-top: 6.5rem;
  font-weight: bold;
  border-width: 1.5px;
  border-style: none;
  padding: 0 0.5rem;
  font-size: 0.9rem;
  line-height: 1rem;
  background-clip: text;
  font-weight: normal;
  color: #222;
  letter-spacing: 0px;
  position: relative;
  z-index: 1;
  color: rgba(255, 255, 255, 1);
  background-color: rgba(255, 255, 255, 0.1);
  border: solid 1px #fff;
  transition: all 0.1s ease;
  border-radius: 7px;
  text-shadow: none;
  /* box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.3) inset; */
}

.down-load span {
  display: inline-block;
}

.ios {
  width: 10rem;
  height: 2.5rem;
  line-height: 2.5rem;
  line-height: 1rem;
  letter-spacing: 0.1rem;
}

.ios img {
  width: 1.1rem;
  height: 1.1rem;
  display: inline-block;
  vertical-align: middle;
  margin-top: -0.2rem;
}

.btn-outer-area .android0 {
  width: 7rem;
  height: 3rem;
  font-size: 0.8rem;
}

.btn-outer-area .android1 {
  width: 9rem;
  font-size: 0.7rem;
  height: 3rem;
}

.btn-outer-area .android0 img,
.btn-outer-area .android1 img {
  display: inline-block;
  width: 1.5rem;
  height: 1.5rem;
  vertical-align: top;
  margin-top: 0.3rem;
}

/* .btn-outer-area .android0 img {
  margin-top: 0.4rem;
} */
.down-load var {
  display: block;
  font-weight: normal;
  font-size: 0.5rem;
  float: left;
  margin-top: 0.5rem;
}

.down-load::before {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  border-radius: 15px;
  /* box-shadow: 0px 0px 4px rgba(255, 255, 255, 1) inset; */
}

.down-load span {
  /* color: transparent;
  background: -webkit-linear-gradient(
    45deg,
    #d3fdff,
    #fde7db,
    #fdf7dc,
    #e6ddff,
    #e4f0ff,
    #d3fdff
  );
  -webkit-background-clip: text; */
  color: #fff;
  /* opacity: 0.9; */
  animation: ran 10s linear infinite;
}

@keyframes jumper {
  0% {
    bottom: 25px;
    backgroud-position: 0 0;
  }
  50% {
    bottom: 45px;
    opacity: 0.5;
    background-position: 2000px 0;
  }
  100% {
    bottom: 25px;
    backgroud-position: 0 0;
  }
}

@keyframes round {
  from {
    left: 0;
  }
  to {
    left: -400%;
  }
}

@keyframes ran {
  from {
    backgroud-position: 0 0;
  }
  to {
    background-position: 1000px 0;
  }
}

.download-icon {
  vertical-align: top;
  font-size: 1rem;
  margin-top: 0.6rem;
  margin-right: 0.1rem;
  background: rgba(200, 200, 200, 0.1);
  padding: 0.4rem;
  border-radius: 50%;
  color: rgba(255, 255, 255, 0.7);
  box-shadow: 0px 0px 4px rgba(255, 255, 255, 0.1) inset;
  /* border: solid 1px #fff; */
  /* color: transparent; */
}

.download-icon::before {
  background: -webkit-linear-gradient(
    45deg,
    #e7feff,
    #fff4ee,
    #fffbe9,
    #f4f0ff,
    #e4f0ff,
    #e7feff
  );
  -webkit-background-clip: text;
  opacity: 0.9;
  animation: ran 30s linear infinite;
}

.btn-outer-area {
  display: flex;
  position: absolute;
  top: 16rem;
  left: 50%;
  transform: translate(-50%, 0);
  box-sizing: border-box;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/components/pe-home/modules/home-page.vue